@if (origin() && destination()) {
  <span>{{ origin().city }}</span>
  <i class="material-icons">arrow_forward</i>
  <span>{{ destination().city }}</span>
} @else if (origin() && !destination()) {
  <span>{{ origin().city }}</span>
} @else if (!origin() && destination()) {
  <span>{{ destination().city }}</span>
} @else {
  <span>{{ '$not_available$' | translate }}</span>
}
